import { KINDS } from '@/components/sections/updates/releases'
import Icon from '@/components/ui/Icon'

/** The small coloured square that marks a kind of change. */
export default function KindDot({ kind }) {
  const { icon, dot } = KINDS[kind]
  return (
    <span
      aria-hidden="true"
      className={`grid size-6 shrink-0 place-items-center rounded-lg ${dot}`}
    >
      <Icon name={icon} size={13} stroke={2.2} />
    </span>
  )
}
